import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classNames from 'classnames';
const DEFAULT_TEXT_COLOR = 'text-color-white';
const DEFAULT_BACKGROUND_COLOR = 'bg-primary';
const ApplicationLayoutBodyBanner = forwardRef((props, ref) => {
    const { textColor = DEFAULT_TEXT_COLOR, backgroundColor = DEFAULT_BACKGROUND_COLOR, isSticky = true, className, children } = props, remainingProps = __rest(props, ["textColor", "backgroundColor", "isSticky", "className", "children"]);
    const bannerClasses = classNames('ApplicationLayoutBodyBanner', textColor, backgroundColor, isSticky && 'position-sticky top-0 z-index-3', className);
    return (_jsx("div", Object.assign({}, remainingProps, { ref: ref, className: bannerClasses }, { children: children })));
});
export default ApplicationLayoutBodyBanner;
